export enum ColumnId {
    LEFT = 'left',
    TOTAL = 'total',
    WINNING_PERCENTAGE = 'winning-percentage',
    WINNING_NUMBER = 'winning-number',
    NEUTRAL_PERCENTAGE = 'neutral-percentage',
    NEUTRAL_NUMBER = 'neutral-number',
    LOSING_PERCENTAGE = 'losing-percentage',
    LOSING_NUMBER = 'losing-number',
}
